import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _EditLightSmall(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M16.538 3.914c.36 0 .653.152.916.353.252.191.53.47.853.794l.633.632c.323.324.602.602.793.853.201.263.353.556.353.916s-.152.652-.353.915c-.191.251-.47.53-.794.852l-8.579 8.579c-.175.175-.326.332-.517.44s-.403.157-.644.218l-3.27.817c-.163.041-.342.087-.49.102-.155.015-.416.01-.626-.199-.209-.209-.213-.47-.198-.625.015-.148.06-.326.102-.49l.817-3.27c.06-.242.11-.453.218-.644.108-.19.264-.341.44-.517l8.579-8.58c.323-.323.6-.602.852-.793.263-.2.555-.353.915-.353ZM14 6l4 4" })));
}
const EditLightSmall = forwardRef(_EditLightSmall);
export { EditLightSmall };
